import * as React from "react";
const SvgFiRrStepForward = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-step-forward_svg__a)">
      <path
        fill="#062147"
        d="M20 0a1 1 0 0 0-1 1v7.482L9.363.782A3.93 3.93 0 0 0 5.19.44 3.93 3.93 0 0 0 3 4.007V20a3.93 3.93 0 0 0 2.191 3.567c.577.293 1.189.44 1.817.44.843 0 1.657-.27 2.388-.809L19 15.516v7.483a1 1 0 1 0 2 0V1a1 1 0 0 0-1-1m-1.851 13.637-9.97 7.976a1.97 1.97 0 0 1-2.085.17A1.94 1.94 0 0 1 4.999 20V4.007c0-.78.399-1.43 1.094-1.782.303-.153.618-.23.926-.23.401 0 .791.128 1.128.375l10.036 8.018c.519.38.816.966.816 1.61s-.298 1.232-.851 1.638z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-step-forward_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStepForward;
